/**
 * Generic Card component applies border, spacing, and flex properties
 * NOTE: Border is transparent by default.  We maintain a border regardless
 *       because a box with and without a border has different dimensions.
 */

import {FCWithHTMLAttributes} from "../types/reactTypes";
import clsMerge from "../util/clsMerge";

type CardProps = {};

const Card: FCWithHTMLAttributes<CardProps> = ({
	className,
	children,
	...props
}) => {
	return (
		<div
			className={clsMerge(
				"flex flex-col justify-center gap-4 rounded border border-solid border-transparent p-6",
				className
			)}
			{...props}
		>
			{children}
		</div>
	);
};

export default Card;
